import qs from 'qs';
import axios from 'axios';

export default {
  fetchObjects: ({commit}) => {
    axios.get('/engine/objects', {
    })
      .then(response => {
        commit('SET_OBJECTS', response.data);
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  createObject: ({commit}, params) => {
    const callback = params && params['callback'] || undefined;
    const payload = {...params};
    delete payload['callback'];
    axios({
      url: '/engine/objects',
      method: 'post',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('ADD_OBJECT', response.data);
        if (typeof callback === "function") {
          try {
            callback(response.data.id);
          } catch (e) {
          }
        }
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  modifyObject: ({commit}, payload) => {
    axios({
      url: '/engine/objects/' + payload.id,
      method: 'put',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_OBJECT', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  deleteObject: ({commit}, id) => {
    axios({
      url: '/engine/objects/' + id,
      method: 'DELETE'
    })
      .then(() => {
        commit('objects/DELETE_OBJECT', id, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addSourceToPropRule: ({commit}, payload) => {
    axios({
      url: '/engine/objects/' + payload.id + '/rules/sources',
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_OBJECT', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  removeSourceFromPropRule: ({commit}, payload) => {
    axios({
      url: '/engine/objects/' + payload.id + '/rules/sources/' + payload.deviceTopicId,
      method: 'DELETE'
    })
      .then((response) => {
        commit('objects/REPLACE_OBJECT', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addPropRule: ({commit}, payload) => {
    axios({
      url: '/engine/objects/' + payload.id + '/rules',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_OBJECT', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  changePropRule: ({commit}, payload) => {
    axios({
      url: '/engine/objects/' + payload.id + '/rules',
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_OBJECT', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  removePropRule: ({commit}, objectId) => {
    axios({
      url: '/engine/objects/' + objectId + '/rules',
      method: 'DELETE'
    })
      .then(response => {
        commit('objects/REPLACE_OBJECT', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addGroup: ({commit}, payload) => {
    axios({
      url: '/engine/groups',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/ADD_GROUP', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  modifyGroup: ({commit}, payload) => {
    axios({
      url: '/engine/groups/' + payload.id,
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_GROUP', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  removeGroup: ({commit}, id) => {
    axios({
      url: '/engine/groups/' + id,
      method: 'DELETE'
    })
      .then(() => {
        commit('objects/REMOVE_GROUP', id, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addObjectToGroup: ({commit}, payload) => {
    axios({
      url: '/engine/groups/' + payload.id + '/objects',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_GROUP', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  removeObjectFromGroup: ({commit}, payload) => {
    axios({
      url: '/engine/groups/' + payload.id + '/objects/' + payload.objectId,
      method: 'DELETE'
    })
      .then((response) => {
        commit('objects/REPLACE_GROUP', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  moveObjectInsideGroupUp: ({commit}, payload) => {
    axios({
      url: '/engine/groups/' + payload.id + '/objects/' + payload.objectId + '/up',
      method: 'POST'
    })
      .then((response) => {
        commit('objects/REPLACE_GROUP', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  moveObjectInsideGroupDown: ({commit}, payload) => {
    axios({
      url: '/engine/groups/' + payload.id + '/objects/' + payload.objectId + '/down',
      method: 'POST'
    })
      .then((response) => {
        commit('objects/REPLACE_GROUP', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  modifyAliasForObjectInGroup: ({commit}, payload) => {
    axios({
      url: '/engine/groups/' + payload.id + '/objects/' + payload.objectId + '/alias',
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_GROUP', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addEndpointToObject: ({commit}, payload) => {
    axios({
      url: '/engine/objects/' + payload.id + '/endpoints',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_OBJECT', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addBoard: ({commit}, payload) => {
    axios({
      url: '/engine/boards',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/ADD_BOARD', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  modifyBoard: ({commit}, payload) => {
    axios({
      url: '/engine/boards/' + payload.id,
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_BOARD', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  removeBoard: ({commit}, id) => {
    axios({
      url: '/engine/boards/' + id,
      method: 'DELETE'
    })
      .then(() => {
        commit('objects/REMOVE_BOARD', id, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  addGroupToBoard: ({commit}, payload) => {
    axios({
      url: '/engine/boards/' + payload.id + '/groups',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then((response) => {
        commit('objects/REPLACE_BOARD', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  removeGroupFromBoard: ({commit}, payload) => {
    axios({
      url: '/engine/boards/' + payload.id + '/groups/' + payload.groupId,
      method: 'DELETE'
    })
      .then((response) => {
        commit('objects/REPLACE_BOARD', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  moveGroupInsideBoardUp: ({commit}, payload) => {
    axios({
      url: '/engine/boards/' + payload.id + '/groups/' + payload.groupId + '/up',
      method: 'POST'
    })
      .then((response) => {
        commit('objects/REPLACE_BOARD', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  moveGroupInsideBoardDown: ({commit}, payload) => {
    axios({
      url: '/engine/boards/' + payload.id + '/groups/' + payload.groupId + '/down',
      method: 'POST'
    })
      .then((response) => {
        commit('objects/REPLACE_BOARD', response.data, {root: true});
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  setObjectState: ({commit}, payload) => {
    const {id, cb, ...rest} = payload;

    axios({
      url: `/engine/objects/${id}`,
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      data: JSON.stringify(rest),
    })
      .then(() => {
        if (typeof cb === "function") {
          cb();
        }
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  runCommandOnObject: ({commit}, payload) => {
    const {id, overlay = true, cb, ...rest} = payload;
    axios({
      url: `/engine/command/${id}`,
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      data: JSON.stringify(rest),
    })
      .then(() => {
        commit('ui/SET_FEEDBACK', { message: "Command enqueued" }, { root: true });
        if (typeof cb === "function") {
          cb();
        }
      })
      .catch(err => {
        commit('ui/SET_FEEDBACK', { message: "Command failed", type: "is-danger" }, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  runDelayedCommandOnObject: ({commit}, payload) => {
    const {id, delay = 0, cb, ...rest} = payload;

    axios({
      url: `/engine/delay/${delay}/command/${id}`,
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      data: JSON.stringify(rest),
    })
      .then(() => {
        if (typeof cb === "function") {
          cb();
        }
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  }
};
